module.exports = __webpack_public_path__ + "a71003db5b0febf328b6892e019c8b88.glb";